import { useState } from "react";
import { Field } from "formik";

export default function PasswordField({ name, id, autoComplete, className = "form-control" }) {
  const [visible, setVisible] = useState(false);

  return (
    <div className="input-group">
      <Field
        type={visible ? "text" : "password"}
        className={className}
        id={id}
        name={name}
        autoComplete={autoComplete}
      />
      <button
        type="button"
        className="btn btn-outline-secondary"
        aria-label={visible ? "Hide password" : "Show password"}
        onClick={() => setVisible((v) => !v)}
      >
        <i className={`bi ${visible ? "bi-eye" : "bi-eye-slash"}`} aria-hidden="true" />
      </button>
    </div>
  );
}
